exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___-_Cs9{padding:.7em 1.1em;width:100%;border-radius:15px;font-weight:600;font-size:16px;color:#fff;min-height:40px;background-color:#9e7fc9;gap:8px;display:flex;align-items:center;cursor:pointer;justify-content:center;text-transform:uppercase}.index-module__wrapper___-_Cs9 svg{font-size:20px}.index-module__popup-wrapper___2WFZ1{display:grid;gap:32px}.index-module__popup-wrapper___2WFZ1 h3{font-size:32px}.index-module__popup-wrapper___2WFZ1 p{color:#333}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___-_Cs9",
	"popup-wrapper": "index-module__popup-wrapper___2WFZ1"
};